import { render, staticRenderFns } from "./ProductCategoryModal.vue?vue&type=template&id=259ef169&scoped=true&"
import script from "./ProductCategoryModal.vue?vue&type=script&lang=js&"
export * from "./ProductCategoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259ef169",
  null
  
)

export default component.exports